const getters = {
  getEmpresa: (state) => state.empresa,
};

export default getters;
